import React, {useRef} from "react"
import { Link } from "gatsby"
import ComponentWrapper from "../components/wrapper"
import ScrollAnimation from "../helpers/scrollAnimations"
import ToolTip from "./tooltip"

const CopySide = ({reverseZindex, column2, column1, ctaButton, ctaButtonColumn1, pinlineColumn1, pinlineColumn2, storyColor, hasTooltip1, tooltip1, hasTooltip2, tooltip2}) => {
    const parentCopyEl1 = useRef(null);
    const parentCopyEl2 = useRef(null);

    return (
        <ComponentWrapper>
            <ScrollAnimation zIndex={reverseZindex}>
                {/* horizontal line goes here */}
                <div className="copy-side">
                    <div className="container">
                        <div className={`left ${pinlineColumn1 ? 'pinline' : ''}`}>
                            {/* change header hoverstate color according to --issue --lens */}
                            <div className={`text text--${storyColor}`} ref={parentCopyEl1} dangerouslySetInnerHTML={{__html: column1}}></div>
                            { ctaButtonColumn1 &&
                                <Link to={ctaButtonColumn1.url} className={`button button--${storyColor}`}>{ctaButtonColumn1.title}</Link>
                            }
                            { hasTooltip1 &&
                                <ToolTip tooltip={tooltip1} storyColor={storyColor} parentCopy={parentCopyEl1} />
                            }
                        </div>

                        <div className={`right ${pinlineColumn2 ? 'pinline' : ''}`}>
                            <div className="text" ref={parentCopyEl2} dangerouslySetInnerHTML={{__html: column2}}></div>
                            { ctaButton &&
                                <Link to={ctaButton.url} className={`button button--${storyColor}`}>{ctaButton.title}</Link>
                            }
                            { hasTooltip2 &&
                                <ToolTip tooltip={tooltip2} storyColor={storyColor} parentCopy={parentCopyEl2} />
                            }
                        </div>
                    </div>
                </div>
            </ScrollAnimation>
        </ComponentWrapper>
    )
}

export default CopySide